export default __webpack_public_path__ + "static/media/BallYellow.1bfdb57e.svg";